module.exports = __webpack_public_path__ + "static/img/iconsetup.77bf059.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iconsetup.png
// module id = sfy1
// module chunks = 1